import YFormStockRateChart from './StockRateChart';

export { YFormStockRateChart };
export default YFormStockRateChart;
